<template>
  <svg width="25" height="24" viewBox="0 0 25 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M21.5 19V10.9782C21.5 10.361 21.2151 9.77838 20.7279 9.39946L13.7279 3.95502C13.0057 3.39329 11.9943 3.39329 11.2721 3.95502L4.27212 9.39946C3.78494 9.77838 3.5 10.361 3.5 10.9782V19C3.5 20.1046 4.39543 21 5.5 21H8.25C9.35457 21 10.25 20.1046 10.25 19V16.25C10.25 15.1454 11.1454 14.25 12.25 14.25H12.75C13.8546 14.25 14.75 15.1454 14.75 16.25V19C14.75 20.1046 15.6454 21 16.75 21H19.5C20.6046 21 21.5 20.1046 21.5 19Z"
      stroke="currentColor" stroke-width="1.5" stroke-linejoin="round"/>
  </svg>
</template>
<script setup lang="ts">
</script>